'use strict';

import _ from 'underscore';
import config from '../js/config';
import * as Features from '../utilities/featureFlags';

class PromoGroupService {

  //If the FF for a promo group is disabled, remove it from the available promo groups to use
  processFeatureFlagsForAutoComplete() {
    if (config.promoGroupSettings && config.promoGroupSettings.promoGroups) {

      this.promoGroupConfigForAutoComplete = config.promoGroupSettings.promoGroups;
    }
  }

  determinePromoGroupForAutoComplete(searchResult) {

    if (this.promoGroupConfigForAutoComplete && this.promoGroupConfigForAutoComplete.length && config.analytics.promoGroupPrefix) {
      let resultPromoGroups = [searchResult.promoGroup || '']; //In a future API, promoGroup will be an array, so this logic will work for that
      if (searchResult.npi) {
        resultPromoGroups.push(config.promoGroupSettings.newProductIndicator);
      };

      let applicablePromoGroups = _.filter(this.promoGroupConfigForAutoComplete, (group) => _.contains(resultPromoGroups, group.promoName));
      if (applicablePromoGroups && applicablePromoGroups.length) {
        let appliedPromoGroupKey = applicablePromoGroups[0] && applicablePromoGroups[0].promoName;
        let promoGroupTranslationKey = config.analytics.promoGroupPrefix + appliedPromoGroupKey.replace(' ', '');
        return promoGroupTranslationKey;
      }
    }
    return '';
  }
}

export default new PromoGroupService();



// WEBPACK FOOTER //
// ./assets/services/PromoGroupService.js